import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GS1LayoutModule } from '@gs1france/gs1-components-library';
import { GS1Document } from '../../models/document.model';
import { DocumentService } from '@services/document.service';
import { StorageService } from '@services/storage.service';
import { UnsubscribeComponent } from '../unsubscribe/unsubscribe.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { take, switchMap, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'footer-comp',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],

  imports: [RouterLink, TranslateModule, GS1LayoutModule, UnsubscribeComponent],
})
export class FooterComponent implements OnInit, OnDestroy {
  private documentService = inject(DocumentService);
  private storageService = inject(StorageService);

  isFederation = toSignal(this.storageService.isUserFederation(), {
    initialValue: false,
  });

  ngOnInit() {}

  ngOnDestroy(): void {}

  CGU() {
    this.documentService
      .getCGU()
      .pipe(
        take(1),
        switchMap((doc) => this.documentService.DownloadDocument(doc.idDoc)),
        take(1),
        catchError(() => of(null))
      )
      .subscribe();
  }

  PolitiqueConfidentialite() {
    this.documentService
      .getPolitiqueConfidentialite()
      .pipe(
        take(1),
        switchMap((doc) => this.documentService.DownloadDocument(doc.idDoc)),
        take(1),
        catchError(() => of(null))
      )
      .subscribe();
  }
}
